import React, { useState, useEffect } from 'react';
import { provincesService } from '../../../services/provincesService';

interface LocationDisplayProps {
  district?: string;
  city?: string;
  districtCode?: number;
  cityCode?: number;
  className?: string;
}

const LocationDisplay: React.FC<LocationDisplayProps> = ({
  district,
  city,
  districtCode,
  cityCode,
  className = '',
}) => {
  const [locationText, setLocationText] = useState<string>('-');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadLocationText = async () => {
      // If we have both district and city names, use them directly
      if (district && city) {
        setLocationText(`${district}, ${city}`);
        return;
      }

      // If we have codes, try to fetch the names
      if (districtCode || cityCode) {
        setIsLoading(true);
        try {
          const promises = [];
          
          if (cityCode) {
            promises.push(provincesService.getProvinceName(cityCode));
          } else {
            promises.push(Promise.resolve(''));
          }
          
          if (districtCode) {
            promises.push(provincesService.getDistrictName(districtCode));
          } else {
            promises.push(Promise.resolve(''));
          }

          const [cityName, districtName] = await Promise.all(promises);
          
          if (cityName && districtName) {
            setLocationText(`${districtName}, ${cityName}`);
          } else if (cityName) {
            setLocationText(cityName);
          } else if (districtName) {
            setLocationText(districtName);
          } else {
            setLocationText('-');
          }
        } catch (error) {
          console.error('Error loading location:', error);
          // Fallback to text values if available
          if (district || city) {
            setLocationText([district, city].filter(Boolean).join(', ') || '-');
          } else {
            setLocationText('-');
          }
        } finally {
          setIsLoading(false);
        }
      } else if (district || city) {
        // Fallback to text values
        setLocationText([district, city].filter(Boolean).join(', ') || '-');
      } else {
        setLocationText('-');
      }
    };

    loadLocationText();
  }, [district, city, districtCode, cityCode]);

  if (isLoading) {
    return (
      <div className={`text-sm text-gray-500 ${className}`}>
        <div className="animate-pulse">Đang tải...</div>
      </div>
    );
  }

  return (
    <div className={`text-sm text-gray-900 ${className}`}>
      {locationText}
    </div>
  );
};

export default LocationDisplay;
